export default "/assets/f24f4bcef8a4a0eb6345d292b85dc7fe.woff";